export const asyncActionType = (type) => ({
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`,
});

export const EPA_FETCH_SUPPORTEDLIST = asyncActionType('EPA_FETCH_SUPPORTEDLIST');
export const EPA_FETCH_ACTIVEPARTNUMBERS = asyncActionType('EPA_FETCH_ACTIVEPARTNUMBERS');
export const FILTERED_COMPONENTS='FILTERED_COMPONENTS';
export const CONTROLLER_CONFIG='CONTROLLER_CONFIG';
export const ERROR_CLOSE='ERROR_CLOSE';
export const CALC_DISABLED='CALC_DISABLED';
export const CHANGE_GATEWAY = 'CHANGE_GATEWAY'
export const SERVER_LIST=asyncActionType('SERVER_LIST');
export const FETCH_NODEQTY=asyncActionType('FETCH_NODEQTY');
export const FETCH_DEFAULT_WRKLD=asyncActionType('FETCH_DEFAULT_WRKLD');
export const ARCVALUE=asyncActionType('ARCVALUE');
export const OSLIST=asyncActionType('OSLIST');
export const EPAVNEXT_FETCH_TEMPLATELIST=asyncActionType('EPAVNEXT_FETCH_TEMPLATELIST');
export const EPICREQUIREMENTS=asyncActionType('EPICREQUIREMENTS');
export const CALCULATEBLUEDATACONFIG=asyncActionType('CALCULATEBLUEDATACONFIG');
export const CALCULATEBLUEDATACONFIGFALSE=asyncActionType('CALCULATEBLUEDATACONFIGFALSE');
export const FETCH_GATEWAYDLTS=asyncActionType('FETCH_GATEWAYDLTS');
export const GETEXTRANODES_QTY=asyncActionType('GETEXTRANODES_QTY');
export const OSLISTBLUEDATA=asyncActionType('OSLISTBLUEDATA');
export const FETCH_ANALYTICSDATABASENODEQTY=asyncActionType('FETCH_ANALYTICSDATABASENODEQTY');
export const TENANTDRIVELIST = asyncActionType('TENANTDRIVELIST');
export const GATEWAY_RECOMMENDATIONS = asyncActionType('GATEWAY_RECOMMENDATIONS');
export const CONTROLLER_RECOMMENDATIONS = asyncActionType('CONTROLLER_RECOMMENDATIONS');
export const MASTER_RECOMMENDATIONS = asyncActionType("MASTER_RECOMMENDATIONS");










// WEBPACK FOOTER //
// ./src/SizerUI/Redux/action_types/epaActionTypes.js